module.exports = __webpack_public_path__ + "static/media/fasterBetAcceptanceIcon.0268b720.svg";